import { InputHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export function Checkbox(props: Props) {
  const { className, ...rest } = props;

  return (
    <input
      type="checkbox"
      className={twMerge(
        'h-5',
        'w-5',
        'shrink-0',
        'cursor-pointer',
        'rounded',
        'border',
        'border-neutral-500',
        'bg-transparent',
        'accent-teal-500',
        'transition-colors',
        'focus-visible:outline',
        'focus-visible:outline-2',
        'focus-visible:outline-offset-2',
        'focus-visible:outline-teal-500',
        'hover:border-neutral-300',
        'disabled:cursor-not-allowed',
        'disabled:opacity-50',
        '[color-scheme:dark]',
        '[&:user-invalid]:border-rose-500',
        className,
      )}
      {...rest}
    />
  );
}
